import { APP_VERSION, IS_DEV_BUILD } from "../../version";

export default function VersionBadge() {
  const { build, commit, builtAt } = APP_VERSION;

  return (
    <span
      className="select-all text-xs text-white/50"
      title={`Build #${build} • ${new Date(builtAt).toLocaleString("bg-BG")}`}
    >
      {IS_DEV_BUILD ? "dev" : `#${build} · ${commit}`}
    </span>
  );
}
